import { useRef, FC, useEffect, useState } from 'react';
import { tailwindOverride, Tooltip } from '@getsynapse/design-system';

interface TruncatedTableColumnProps {
  content: string | React.ReactNode;
  className?: string;
  value?: string;
}

const TruncatedTableColumn: FC<TruncatedTableColumnProps> = ({
  content,
  className = '',
  value,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      if (ref.current) {
        const element = ref.current;
        const isTextTruncated = element.scrollWidth > element.clientWidth;
        setIsTruncated(isTextTruncated);
      }
    };

    checkTruncation();

    window.addEventListener('resize', checkTruncation);
    return () => window.removeEventListener('resize', checkTruncation);
  }, [content]);

  const contentElement = (
    <div ref={ref} className={tailwindOverride('truncate', className)}>
      {content}
    </div>
  );

  if (isTruncated) {
    return (
      <Tooltip
        trigger={contentElement}
        openMode='hover1'
        position='topCenter'
        contentProps={{
          className: tailwindOverride(
            'bg-neutral-darker shadow-tooltip',
            'rounded-xs px-2 py-1',
            'absolute',
            'w-max',
            'whitespace-normal break-words',
            'text-sm',
            'leading-6',
            'font-normal',
            'tracking-normal',
            'z-50'
          ),
        }}
        timeout={0}
        showPopper
        className={`w-full truncate`}
        usePortal
      >
        {value || content}
      </Tooltip>
    );
  }

  return contentElement;
};

export default TruncatedTableColumn;
